import { render } from "./IngredientCheckerHistory.vue?vue&type=template&id=85a042f2"
import script from "./IngredientCheckerHistory.vue?vue&type=script&lang=js"
export * from "./IngredientCheckerHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__